export default __webpack_public_path__ + "static/media/logo_light.4eeb093a.png";